<template>
    <v-container class="mb-12">
        <v-card>
            <question-content-navigator></question-content-navigator>

            <v-card-text class="body-1 black--text" :style="fontSizeInlineStyle">
                <div
                    v-if="question.image"
                    v-viewer='{ "inline": false, "button": true, "navbar": false, "title": false, "toolbar": false, "tooltip": false, "movable": true, "zoomable": true, "rotatable": false, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }'
                    class="d-flex justify-center"
                    >
                        <img width="400" :src="assetUrl(question.image)">
                </div>

                {{ question.question }}

                <v-sheet class="answers">
                    <div
                        v-for="(choice, idx) in question.answers"
                        :key="idx"
                        @click="setAnswer(choice.id)"
                        v-ripple
                        :class="{ 'selected-answer': answer.answer_id === choice.id}"
                    >
                        {{ idxToOptionChar(idx) }}. {{ choice.answer }}
                    </div>
                </v-sheet>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import { get } from 'vuex-pathify'
import assetUrl from '@/tools/assetUrl'
import QuestionContentNavigator from './QuestionContentNavigator'
import idxToOptionChar from '@/tools/idxToOptionChar'

export default {
    components: {
        QuestionContentNavigator,
    },

    computed: {
        question: get('tryout/activeQuestion'),

        answer: get('tryout/activeAnswer'),

        fontSizeInlineStyle: get('tryout/fontSizeInlineStyle'),
    },

    methods: {
        idxToOptionChar,
        assetUrl,

        setAnswer(answer_id) {
            const history_hash = this.$store.get('tryout/history_hash')
            const idx = this.$store.get('tryout/activeQuestionIdx')
            this.$tracking.event.tryout.answer(
                `${this.$store.get('tryout/title')} ${this.$store.get('enrollment/selected@title')}`,
                this.$store.get('tryout/activeQuestionIdx') + 1
            )

            this.$api.put(`work/${history_hash}/${this.question.id}`, {
                answer_id: answer_id,
                active_time: this.$store.get('tryout/activeAnswer@active_time')
            })

            this.$store.set(`tryout/answers@${idx}.answer_id`, answer_id)

            if (this.$store.get('tryout/autoScroll')) {
                setTimeout(() => {
                    if (this.$store.get('tryout/activeQuestionIdx') + 1 < this.$store.get('tryout/questions').length) {
                        this.$store.set('tryout/activeQuestionIdx', this.$store.get('tryout/activeQuestionIdx') + 1)
                    }
                }, 200)
            }
        },
    }
}
</script>
